<template>
    <span></span>
</template>
<script>
    export default {
        props: ['message', 'type', 'title', 'action_url'],
        mounted() {
            let options = {};

            if (this.action_url) {
                options.onClick = function() {
                    window.location.href = this.action_url;
                }
            }

            toastr[this.type](this.message, this.title || '', options);

            this.$emit('on_notification', {
                title: this.title,
                short_desc: this.message,
                type: this.type,
                viewed: 'yes',
                created_at: 'just now'
            });
        }
    }
</script>
